import { useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";
import { postApiSetting } from "../assets/functions";
import { useEffect } from "react";
import { ToastContainer, toast } from 'react-toastify';
import logo from '../assets/logo.png';

export default function Login ({setAuth}) {


    const LoginData = JSON.parse(sessionStorage.getItem('LoginData'))
    const { register, handleSubmit, formState:{ errors } } = useForm();

    const navigate = useNavigate();
    useEffect(()=>{
        if(LoginData){
            setAuth(false)
        }
    },[])

    const loginSubmit = async (data) => {
        // console.log(data);
        let settings = postApiSetting(data)
        try {
            // let res = await fetch('api/Admin/signIn', settings)
            let res = await fetch('/Admin/api/Admin/signIn', settings)
            let result = await res.json()
            console.log(res)
            console.log(result)
            if(res.status !== 200){
                // alert('something went wrong : '+ res.status)
                toast.error('something went wrong : '+ res.status, {position: 'top-center',});

            }else{
                if(result.data.responseCode === '00'){
                    // alert('SUCCESS : '+result.data.responseMsg)
                     sessionStorage.setItem('token',result.data.token)
                    setAuth(true)
                    navigate("/dashboard");
                }else{
                    // alert('FAILED : '+result.data.responseMsg)
                    toast.error('FAILED : '+result.data.responseMsg, {position: 'top-center',});

                }
            }
        } catch (error) {
            console.log(error)
        }
    }

    return (
        <div className="login-shell d-flex flex-wrap">
            <ToastContainer />

            <div className="login-brand-panel d-none d-lg-flex flex-column justify-content-center col-lg-6">
                <img src={logo} alt="Company logo" />
                <h2>Payments, under one command center.</h2>
                <p>Onboard merchants, manage payin &amp; payout wallets, and track every transaction from a single admin console.</p>
            </div>

            <div className="col-12 col-lg-6 d-flex align-items-center justify-content-center p-4">
                <form className="login-card" onSubmit={handleSubmit(loginSubmit)} noValidate>
                    <h1 className="h4 fw-bold mb-1 text-center">Welcome back</h1>
                    <p className="text-secondary text-center small mb-4">Sign in to the admin console</p>

                    <div className="mb-3">
                        <label className="form-label" htmlFor="loginUserId">User ID <strong className='text-danger'>*</strong></label>
                        <div className="input-group">
                            <span className="input-group-text"><i className="fa-solid fa-user"></i></span>
                            <input id="loginUserId" type="text" className="form-control shadow-none" autoComplete="username"
                                aria-invalid={errors.userId ? "true" : "false"}
                                {...register('userId', { required : { value:true, message:"This field is required" } })} />
                        </div>
                        {errors.userId && <strong className="text-danger d-block mt-1"><small>{errors.userId.message}</small></strong>}
                    </div>
                    <div className="mb-4">
                        <label className="form-label" htmlFor="loginPassword">Password <strong className='text-danger'>*</strong></label>
                        <div className="input-group">
                            <span className="input-group-text"><i className="fa-solid fa-lock"></i></span>
                            <input id="loginPassword" type="password" className="form-control shadow-none" autoComplete="current-password"
                                aria-invalid={errors.password ? "true" : "false"}
                                {...register('password', { required : { value:true, message:"This field is required" } })} />
                        </div>
                        {errors.password && <strong className="text-danger d-block mt-1"><small>{errors.password.message}</small></strong>}
                    </div>
                    <button type="submit" className="btn _themebg-0 text-white w-100">Sign In</button>
                </form>
            </div>
        </div>
    )
}